export default "__VITE_ASSET__DJ7Rakj$__"